import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import noop from '../noop';
/** returns whether current user is logged in,
 *  a dispatched action that sends the user to the sisu login pages,
 *  and a function that will call a callback if logged in, send to login if not */
export function useRestrictToLoggedIn() {
    var isLoggedIn = useSelector(getIsLoggedIn);
    var dispatch = useDispatch();
    var sendUserToJoinPage = useCallback(function (restrictedActionName, returnTo) {
        dispatch(restrictLoggedOut({ restrictedActionName: restrictedActionName, returnTo: returnTo }));
    }, [dispatch]);
    var restrictToLoggedIn = useCallback(function (restrictedActionName, callback) {
        if (callback === void 0) { callback = noop; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return !isLoggedIn
                ? sendUserToJoinPage(restrictedActionName)
                : callback.apply(void 0, args);
        };
    }, [isLoggedIn, sendUserToJoinPage]);
    return { isLoggedIn: isLoggedIn, sendUserToJoinPage: sendUserToJoinPage, restrictToLoggedIn: restrictToLoggedIn };
}
//# sourceMappingURL=useRestrictToLoggedIn.js.map